import { globalConfig } from "../config/global_config";

export const endpoints = {
  login: "/auth/login",
  register: "/auth/register",
  userPing: "/auth/ping",
  getAuthURL: "/auth/getAuthURL",
  getEventFilters: "/inventory/getEventFilters",
  getInventoryFilters: "/inventory/getInventoryFilters",
  getInventory: "/inventory/getInventory",
  getPreviewInventory: "/inventory/getPreviewInventory",
  linkTicketmasterAccount: "/auth/linkTicketmasterAccount",
  manageCart: "/cart/manageCart",
  manageCartForSimilarSeats: "/cart/manageCartForSimilarSeats",
  autoSeatSelection: "/cart/autoSeatSelection",
  cancelCart: "/cart/cancelCart",
  checkoutCart: "/cart/checkout",
  addServiceFee: "/cart/addServiceFee",
  getPaymentToken: "/cart/getPaymentToken",
  getTransactionHistory: "/transaction/history",

  // perks
  getPerks: "/perk/getPerks",
  managePerks: "/perk/managePerks",

  // giftCard
  purchaseGiftCard: "/giftCard/purchaseGiftCard",
  getGiftCards: "/giftCard/getGiftCards",
  redeemGiftCard: "/giftCard/redeemGiftCard",
  getGiftCardSalesByAccountId: "/giftCard/getGiftCardSalesByAccountId",

  // credit
  getCreditPacks: "/credit/getCreditPacks",
  getCreditReport: "/credit/getCreditReport",
  getCheckoutCredit: "/credit/getCheckoutCredit",
  purchaseCredit: "/credit/purchaseCredit",
  lockSeatsForCredit: "/credit/lockSeatsForCredit",
  cancelCartForCredit: "/credit/cancelCartForCredit",

  //card
  getCard: "/card/get",
  saveCard: "/card/save",

  // broker
  addBrokerEmail: "/broker/addBrokerEmail",
  checkBrokerEmail: "/broker/checkBrokerEmail",
  getZipCodeLists: "/broker/getZipCodeLists",
  addAccountRestriction: "/broker/addAccountRestriction",

  getUserVendorMapping: "/auth/getUserVendorMapping",
  refreshToken: "/auth/refreshToken",
  getPlans: "/plans/getPlans",
  getAllPlans: "/plans/getAllPlans",
  checkout: "/transaction/checkout",
  insertAdditionalDetails: "/cart/insertAdditionalDetails",
  getAllFilters: "/events/getAllFilters",

  // events
  getUpcomingEvents: "/inventory/getUpcomingEvents",
  getMyEvents: "/events/getMyEvents",
  getPackages: "/package/getPackages",
  getProductSales: "/events/getProductSales",
  refreshEvent: "/inventory/refreshEvent",
  getPacksMapping: "/inventory/getPacksMapping",

  claim: "/claim/claim",
  purchaseHistory: "/claim/purchaseHistory",
  getTmAuthUrl: "/auth/getAuthURL",
  linkTmAccount: "/auth/linkTicketmasterAccount",
  unlinkVendorAccount: "/auth/unlinkVendorAccount",
  forgotPassword: "/auth/forgotPassword",
  resetPassword: "/auth/resetPassword",
  getCustomerAccount: "/auth/getCustomerAccount",

  // payment plans
  getPaymentPlans: "/paymentPlans/getPaymentPlans",

  findAndRetrieveEkataScore: "/cart/findAndRetrieveEkataScore",

  // ticket transfer
  addRecipient: "/ticketTransfer/addRecipient",
  getTicketTransferDetails: "/ticketTransfer/getTicketTransferDetails",
  updateRecipientSeatCount: "/ticketTransfer/updateRecipientSeatCount",
  updateRecipientStatus: "/ticketTransfer/updateRecipientStatus",
  getDetailsByTransferCode: "/ticketTransfer/getDetailsByTransferCode",
  transferTickets: "/ticketTransfer/transferTickets",
};

const serverUrl = globalConfig.backendUrl;
for (const endpoint in endpoints) {
  type Key = keyof typeof endpoints;
  endpoints[endpoint as Key] = serverUrl + endpoints[endpoint as Key];
}
